import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { Loading } from "../../../../legacy/components/Loading";
import { useMobileOnboardingGuard } from "../hooks/useMobileOnboardingGuard";

interface MobileOnboardingGuardProps {
  readonly children: ReactNode;
}

export function MobileOnboardingGuard(props: MobileOnboardingGuardProps): JSX.Element {
  const { children } = props;
  const { isLogged, loading, error, onboardingPath } = useMobileOnboardingGuard();

  if (loading) {
    return <Loading />;
  }

  if (error !== null) {
    throw error;
  }

  if (isLogged) {
    return <Navigate to={onboardingPath} replace />;
  }

  return <>{children}</>;
}

export default MobileOnboardingGuard;
